import yup from './yup'
import moment from 'moment'

export const eventFormSchema = yup.object().shape({
  title: yup.string().label('Title').trimmedRequired('Event Title is required'),
  venueId: yup.string().label('Building').required(),
  startDate: yup.date().label('Start Date').required().typeError('Invalid date'),
  endDate: yup
    .date()
    .typeError('Invalid date')
    .label('End date')
    .test('Date Check', 'End date must be after start date.', function (value) {
      const startDate = moment(this.parent.startDate)
      const endDate = moment(value)
      return endDate.isSameOrAfter(startDate, 'date')
    })
    .test('Time Check', 'End time must be after start time.', function (value) {
      const startDate = moment(this.parent.startDate)
      const endDate = moment(value)
      return endDate.isSameOrAfter(startDate)
    })
    .required(),
  cardStyle: yup.string('Event Card Style').required().label('Card color'),
  moderators: yup.array().label('Moderators').nullable(),
  speakers: yup.array().label('Speakers').nullable(),
  sponsors: yup.array().label('Sponsors').nullable(),
  tags: yup.array().label('Tags').nullable(),
  keynotes: yup.string().label('Keynotes'),
  havePolls: yup.string().oneOf(['yes', 'no']),
  pollIds: yup.array().when('havePolls', {
    is: 'yes',
    then: yup.array().label('Associated Polls').min(1, 'Select at least one poll').required()
  })
})
